import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';

@Component({
  selector: 'app-materials-from-client',
  templateUrl: './materials-from-client.component.html',
  styleUrls: ['./materials-from-client.component.scss']
})
export class MaterialsFromClientComponent {
  materialschekList = {
    projName: false,
    compName: false,
    compLogo: false,
    projLogo: false,
    renders: false,
    renders360: false,
    plans: false,
    projBook: false,
    videoClip: false,
    appartmentsExel: false
  }
  compId: string = "";
  projUid: string = "";
  proj: any;

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
  ) {
    this.compId = this.route.snapshot.params.id;
    this.projUid = this.route.snapshot.params.idp;
  }

  ngOnInit(): void {
    this.dataService.getSpecProject(this.projUid).subscribe(proj => {
      if (proj.length > 0) {
        this.proj = proj[0];
      }
    });
  }

}
